import { defineComponent as _defineComponent } from 'vue'
import { tailwindSurfaceFontClass } from '@@/bits/font'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceQrCodeStore } from '@@/pinia/surface_qr_code'
import SurfaceBuilder from '@@/vuecomponents/SurfaceBuilder.vue'
import SurfaceTitleDescription from '@@/vuecomponents/SurfaceTitleDescription.vue'
import ProcessedImage from '@@/vuecomponents/processed_image.vue'
import { storeToRefs } from 'pinia'
import { computed, nextTick, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceTitleMobile',
  props: {
    isCollapsed: { type: [Boolean, null], default: null }
  },
  emits: ['title-changed', 'description-changed', 'portrait-changed', 'toggle-header'],
  setup(__props: any, { emit }) {

const props = __props as { isCollapsed: boolean | null };





const surfaceStore = useSurfaceStore()
const { title, description, portrait, backgroundLuminance, colorScheme, fontId, isMap, links } =
  storeToRefs(surfaceStore)

const { pinnedQrCodeUrl, xPinnedQrCode } = storeToRefs(useSurfaceQrCodeStore())

const PORTRAIT_SIZE = 32

const titleEl = ref<HTMLHeadingElement>()
const titlePlaceholderForCaretPosition = ref<HTMLHeadingElement>()

const isLongTitle = ref<boolean>(false)

const fontClass = computed<string>(() => {
  return tailwindSurfaceFontClass(fontId.value)
})

const xPortrait = computed<boolean>(() => xPinnedQrCode.value || !!portrait.value)

const updateCaretPosition = (): void => {
  const titlePlaceholderForCaretPositionEl = titlePlaceholderForCaretPosition.value
  if (!titleEl.value || !titlePlaceholderForCaretPositionEl) return
  if (titleEl.value.offsetHeight > 26) {
    isLongTitle.value = true
  } else {
    isLongTitle.value = false
  }
  titlePlaceholderForCaretPositionEl.innerText = ''
  nextTick(() => {
    if (!titlePlaceholderForCaretPositionEl) return
    if (!props.isCollapsed) {
      const titleWords = title.value.split(' ')
      let titleFirstLine = ''
      titleWords.every((word): boolean => {
        const nextTitleFirstLine = !titleFirstLine ? word : `${titleFirstLine} ${word}`
        titlePlaceholderForCaretPositionEl.innerText = nextTitleFirstLine
        if (titlePlaceholderForCaretPositionEl.offsetHeight > 26) {
          titlePlaceholderForCaretPositionEl.innerText = titleFirstLine
          return false
        }
        titleFirstLine = nextTitleFirstLine
        return true
      })
    } else {
      titlePlaceholderForCaretPositionEl.innerText = title.value
    }
  })
}

watch(title, (): void => {
  emit('title-changed')
})

watch(description, (): void => {
  emit('description-changed')
})

watch(portrait, (): void => {
  emit('portrait-changed')
})

watch([() => props.isCollapsed, title, portrait], updateCaretPosition)

onMounted((): void => {
  updateCaretPosition()
})

return { __sfc: true,props, emit, surfaceStore, title, description, portrait, backgroundLuminance, colorScheme, fontId, isMap, links, pinnedQrCodeUrl, xPinnedQrCode, PORTRAIT_SIZE, titleEl, titlePlaceholderForCaretPosition, isLongTitle, fontClass, xPortrait, updateCaretPosition, ImageThumbnail, OzIcon, SurfaceBuilder, SurfaceTitleDescription, ProcessedImage }
}

})